import { render, staticRenderFns } from "./ResourceCategoriesList.vue?vue&type=template&id=37aa53a6&"
import script from "./ResourceCategoriesList.vue?vue&type=script&lang=js&"
export * from "./ResourceCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports